import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { useScanBatchIds } from 'src/hooks'
import { ETranslationNs, IScanCreateForm } from 'src/types'
import { AutocompleteInput } from './auto-input.component'

export const BatchIdInput = () => {
  const [t] = useTranslation(ETranslationNs.ScanForm)
  const { values } = useFormikContext<IScanCreateForm>()
  const { data, isLoading } = useScanBatchIds(values.product_id)

  return (
    <AutocompleteInput
      inputName="batch_id"
      inputUpperLabel={t('batch-input-label.v')}
      inputPlaceholder={t('batch-input-placebolder.v')}
      data={data?.data}
      isLoading={isLoading}
    />
  )
}
